<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.77786 2.90297H15.2229C15.6812 2.89106 16.1259 3.05042 16.4592 3.34607C16.7925 3.64172 16.9873 4.04949 17.0008 4.47988V15.5174C16.9873 15.9478 16.7925 16.3556 16.4592 16.6512C16.1259 16.9469 15.6812 17.1062 15.2229 17.0943H2.77786C2.31954 17.1062 1.87492 16.9469 1.54159 16.6512C1.20827 16.3556 1.01348 15.9478 1 15.5174V4.47988C1.01348 4.04949 1.20827 3.64172 1.54159 3.34607C1.87492 3.05042 2.31954 2.89106 2.77786 2.90297V2.90297Z"
      stroke="#1E264C"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.8516 1.09375V4.57216"
      stroke="#1E264C"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.44531 1.09375V4.57216"
      stroke="#1E264C"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M1 7.07422H17.0008" stroke="#1E264C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
